import UnstableDataFragment from './UnstableDataFragment'

export default `
  query GetUnstableData($context: String!) {
    getUnstableData(context: $context) {
        ...UnstableDataFragment
    }
  } 
  ${UnstableDataFragment}
`
